export default {
  hero: {
    title: '全面的なカスタマーサポートサービス',
    subtitle: '要件定義から継続的な最適化まで、ライフサイクル全体にわたるプロフェッショナルなサポートを提供し、ビジネスの安定稼働を確保します'
  },
  serviceProcess: {
    title: 'サービスプロセス',
    steps: {
      step1: {
        title: '要件定義',
        description: 'お客様のビジネスニーズを深く理解し、専門的なコンサルティングを提供'
      },
      step2: {
        title: 'ソリューション設計',
        description: 'ビジネス要件に合わせたカスタムソリューションを設計'
      },
      step3: {
        title: '実装・展開',
        description: 'プロフェッショナルチームによる効率的な実装とシームレスな展開'
      },
      step4: {
        title: '運用サポート',
        description: '7×24時間監視と迅速な問題対応'
      },
      step5: {
        title: '最適化・アップグレード',
        description: 'システムパフォーマンスの継続的な最適化とアップグレード提案'
      }
    }
  },
  helpCenter: {
    title: 'ヘルプセンター',
    categories: {
      title: 'よくある質問カテゴリー',
      service: 'サービス相談',
      trouble: '障害報告',
      compliance: 'コンプライアンス照会',
      technical: '技術サポート',
      account: 'アカウント管理'
    },
    needMoreHelp: 'さらにサポートが必要ですか？',
    onlineSupport: 'オンラインカスタマーサービス',
    searchPlaceholder: 'ヘルプセンターを検索...',
    faq: {
      service: {
        title: 'サービス相談',
        q1: {
          question: '思棟株式会社はどのような技術サポートサービスを提供していますか？',
          answer: {
            intro: '思棟株式会社は包括的な技術サポートサービスを提供しています：',
            list: [
              '7×24時間システム監視とインシデント対応',
              'リモート技術サポートと問題診断',
              '定期的なシステムヘルスチェックとパフォーマンス最適化',
              'セキュリティ脆弱性評価と修復提案',
              'システムアップグレードと移行サポート',
              'カスタマイズされたトレーニングサービス'
            ],
            conclusion: 'お客様のニーズに応じて、基本サポートからエンタープライズ専属サービスチームまで、さまざまなサービスレベルを提供しています。'
          }
        },
        q2: {
          question: '新しいサービスの申し込みや既存サービスのアップグレードはどのように行いますか？',
          answer: {
            intro: '新しいサービスの申し込みや既存サービスのアップグレードは、以下の方法で行えます：',
            list: [
              '顧客管理プラットフォームにログインし、「サービス管理」ページから申請',
              '{serviceEmail} にメールでご要望を送信',
              'カスタマーサービスホットライン400-123-4567に電話',
              'オンラインカスタマーサービスシステムでリアルタイム相談'
            ],
            conclusion: '当社のサービスチームが1営業日以内にご連絡し、具体的な要件と実施計画について協議いたします。'
          }
        },
        q3: {
          question: 'サービス契約の有効期間はどのくらいですか？更新方法は？',
          answer: {
            intro: '標準サービス契約の有効期間は1年です。契約満了の30日前に更新リマインダーをお送りします。更新プロセスは簡単です：',
            list: [
              '顧客管理プラットフォームにログインして更新オプションを確認',
              'サービス内容と価格を確認',
              'オンラインで電子契約に署名',
              '支払いを完了'
            ],
            conclusion: '長期的なパートナーには優遇価格と追加サービス特典をご提供しています。'
          }
        }
      },
      trouble: {
        title: '障害報告',
        content: '障害報告に関するFAQコンテンツがここに表示されます...'
      },
      compliance: {
        title: 'コンプライアンス照会',
        content: 'コンプライアンス照会に関するFAQコンテンツがここに表示されます...'
      },
      technical: {
        title: '技術サポート',
        content: '技術サポートに関するFAQコンテンツがここに表示されます...'
      },
      account: {
        title: 'アカウント管理',
        content: 'アカウント管理に関するFAQコンテンツがここに表示されます...'
      }
    },
    instantHelp: {
      title: '今すぐサポートが必要ですか？',
      subtitle: '技術サポートチームがいつでもお手伝いいたします',
      hotline: 'サービスホットライン',
      hotlineValue: '400-123-4567',
      email: 'メール',
      emailLocalPart: 'support',
      serviceTime: 'サービス時間',
      serviceTime24x7: '7×24時間',
      contactSupport: '技術サポートに連絡'
    }
  },
  sla: {
    title: 'サービスレベル契約（SLA）',
    description: 'さまざまなニーズのお客様に対応したサービス保証レベルをお約束します。以下は当社のサービスレベル契約の概要です。詳細なSLA文書については、アカウントマネージャーにお問い合わせください。',
    table: {
      serviceItem: 'サービス項目',
      enterprise: 'エンタープライズ',
      professional: 'プロフェッショナル',
      standard: 'スタンダード',
      responseTime: '応答時間',
      criticalResolution: '解決時間（重大障害）',
      generalResolution: '解決時間（一般障害）',
      availability: 'システム可用性',
      supportMethod: 'サポート方法',
      supportMethod_enterprise: '電話+リモート+現地',
      supportMethod_professional: '電話+リモート',
      supportMethod_standard: 'リモートサポート',
      accountManager: '専属アカウントマネージャー',
      compensation: '補償基準（サービス中断）',
      compensation_enterprise: 'サービス時間×50倍',
      compensation_professional: 'サービス時間×30倍',
      compensation_standard: 'サービス時間×10倍',
      values: {
        responseTime: { enterprise: '15分', professional: '1時間', standard: '4時間' },
        criticalResolution: { enterprise: '2時間', professional: '8時間', standard: '24時間' },
        generalResolution: { enterprise: '8時間', professional: '24時間', standard: '48時間' },
        availability: { enterprise: '99.99%', professional: '99.9%', standard: '99.5%' }
      }
    },
    levels: {
      enterprise: {
        title: 'エンタープライズサービス',
        description: '重要なビジネスシステムに最高レベルの保証を提供し、システムの安定性に非常に高い要求を持つ大企業に適しています。',
        features: [
          '7×24時間専属サポートチーム',
          '15分以内の迅速な対応',
          '現地サポートサービス',
          '四半期ごとのシステムヘルスチェック'
        ],
        learnMore: '詳細を見る'
      },
      professional: {
        title: 'プロフェッショナルサービス',
        description: '重要なビジネスシステムに包括的な保証を提供し、中大企業のコアビジネスシステムに適しています。',
        features: [
          '平日8×12時間サポート',
          '1時間以内の対応',
          'リモート優先サポート',
          '半年ごとのシステムヘルスチェック'
        ],
        learnMore: '詳細を見る'
      },
      standard: {
        title: 'スタンダードサービス',
        description: '一般的なビジネスシステムに基本的な保証を提供し、小規模企業や非コアビジネスシステムに適しています。',
        features: [
          '平日8時間サポート',
          '4時間以内の対応',
          'リモートサポートサービス',
          '年次システムヘルスチェック'
        ],
        learnMore: '詳細を見る'
      }
    }
  },
  feedback: {
    title: 'アフターサービスのフィードバックと苦情',
    subtitle: 'サービス評価機能は終了しました。問題の報告、ご意見の共有、苦情の申し立てが必要な場合は、以下の窓口よりご連絡ください。速やかに対応いたします。',
    evaluation: {
      title: 'サービス評価',
      subtitle: 'お客様のフィードバックは非常に重要であり、サービス品質の継続的な向上に役立ちます',
      serviceType: 'サービスタイプ',
      serviceTypePlaceholder: 'サービスタイプを選択してください',
      serviceTypes: {
        technical: '技術サポート',
        consulting: 'コンサルティングサービス',
        implementation: '実装・展開',
        training: 'トレーニングサービス',
        other: 'その他のサービス'
      },
      satisfaction: '総合満足度',
      detailedFeedback: '詳細な評価',
      feedbackPlaceholder: '当社のサービスに関するご意見やご提案をお聞かせください...',
      acceptNotification: '今後のサービス改善に関する通知を受け取ることに同意します',
      submit: '評価を送信',
      successMessage: 'ご評価ありがとうございます！お客様のフィードバックを真摯に受け止めます。'
    },
    complaint: {
      title: 'フィードバック・苦情窓口',
      subtitle: '納品、運用、対応速度、コミュニケーションに関するご意見やエスカレーションが必要な場合は、以下の方法でご連絡ください。営業時間内に順次対応いたします。',
      hotline: {
        title: '苦情ホットライン',
        phone: '400-123-4567 内線 8',
        time: 'サービス時間：平日 9:00-18:00'
      },
      email: {
        title: '苦情メール',
        localPart: 'complaint',
        response: '24時間以内にメールで返信いたします'
      },
      online: {
        title: 'オンライン苦情',
        description: '顧客管理プラットフォームから苦情フォームを送信',
        tracking: '苦情処理の進捗状況をリアルタイムで確認可能'
      },
      process: {
        title: '苦情処理フロー',
        steps: [
          'フィードバックまたは苦情内容を送信',
          'カスタマーサービスが受領確認（24時間以内）',
          '関連部門が調査・処理',
          '解決策または対応方針を提示',
          'お客様が処理結果を確認'
        ]
      }
    }
  },
  cta: {
    title: 'さらにサポートが必要ですか？',
    subtitle: 'カスタマーサポートチームがプロフェッショナルなサービスを提供し、あらゆる問題を解決いたします',
    contactSupport: 'カスタマーサポートに連絡',
    viewDocumentation: 'ヘルプドキュメントを見る'
  },
  chat: {
    title: 'オンラインカスタマーサービス',
    placeholder: 'ご質問を入力してください...',
    welcome: 'こんにちは！私はインテリジェントカスタマーサービスアシスタントです。どのようにお手伝いできますか？',
    assistant: 'カスタマーサービス',
    me: '私',
    justNow: 'たった今',
    autoReply: 'お問い合わせありがとうございます。カスタマーサービススタッフがすぐに返信いたします。'
  }
}
